import React, { useEffect, useState } from "react";
import ActivityBarChart from "../ActivityBarChart";
import ThriveModal from "../../common/ThriveModal";
import { Box, Typography } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import CaseCard from "../../IDEACoreCRM/CaseCard";
import { axiosInstance } from "../../../utils/networking";
interface InteractiveBarChartProps {
  user: any;
  userStats: any;
  startDate: any;
  endDate: any;
}
const InteractiveBarChart: React.FC<InteractiveBarChartProps> = ({
  user,
  userStats,
  startDate,
  endDate,
}) => {
  const [cardOpen, setCardOpen] = useState(false);
  const [barKey, setBarKey] = useState("");
  const [caseList, setCaseList] = useState<any>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!cardOpen || !barKey) {
      return;
    }

    const fetchActivityCases = async () => {
      try {
        setLoading(true);
        const response = await axiosInstance.get(
          `/activity/activities?user_id=${
            user.userId
          }&activity_type=${encodeURIComponent(
            barKey
          )}&start_date=${encodeURIComponent(
            startDate
          )}&end_date=${encodeURIComponent(endDate)}`
        );
        const data = response.data;

        setCaseList(data.caseList);
        setLoading(false);
      } catch (error) {
        console.error("Error fetching activity cases:", error);
        setLoading(false);
      }
    };

    fetchActivityCases();
  }, [barKey, cardOpen, startDate, endDate, user.userId]);

  return (
    <div className="h-full">
      <ActivityBarChart
        data={userStats.userStats}
        barClickable={true}
        setCardOpen={setCardOpen}
        setBarKey={setBarKey}
      />
      <ThriveModal
        width={1280}
        open={cardOpen}
        setOpen={setCardOpen}
        contentComponent={
          <Box>
            <Box
              sx={{
                textAlign: "center",
                backgroundColor: "#9E1F63FF",
                padding: "3px",
                margin: 0,
                color: "white",
                borderRadius: "5px 5px 0 0",
                marginBottom: "20px",
              }}
            >
              <Typography sx={{ display: "inline-block" }} variant="h4">
                {user.role === "admin"
                  ? barKey
                  : `${user.firstName} ${user.lastName} - ${barKey}`}
              </Typography>
              <Box
                sx={{ display: "inline", float: "right", cursor: "pointer" }}
                onClick={() => {
                  setCardOpen(false);
                  setLoading(true);
                  setCaseList([]);
                }}
              >
                <CloseIcon sx={{ fontSize: 40 }}></CloseIcon>
              </Box>
            </Box>

            {loading ? (
              <Typography>Loading...</Typography>
            ) : caseList.length === 0 ? (
              <Typography>No cases found for this activity.</Typography>
            ) : (
              <div className="grid grid-cols-8 gap-2 overflow-auto max-h-[550px]">
                {caseList.map((caseItem: any, index: number) => (
                  <CaseCard case={caseItem} key={index} />
                ))}
              </div>
            )}
          </Box>
        }
      ></ThriveModal>
    </div>
  );
};

export default InteractiveBarChart;
